(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-inclusions-modal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-inclusions-modal')) {
    customElements.define(
      'product-inclusions-modal',
      class ProductInclusionsModal extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;

          const selector = 'a[href="#' + this.dialog.id + '"]';
          this.triggers = Array.from(document.querySelectorAll(selector));
          this.closeButton = this.querySelector('[data-inclusions-close]');
          this.openModal = this.openModal.bind(this);
          this.closeModal = this.closeModal.bind(this);
          this.handleBackdropClick = this.handleBackdropClick.bind(this);
          this.handleClose = this.handleClose.bind(this);

          this.triggers.forEach((trigger) => trigger.addEventListener('click', this.openModal));
          this.closeButton?.addEventListener('click', this.closeModal);
          this.dialog.addEventListener('click', this.handleBackdropClick);
          this.dialog.addEventListener('close', this.handleClose);
        }

        disconnectedCallback() {
          this.triggers?.forEach((trigger) => trigger.removeEventListener('click', this.openModal));
          this.closeButton?.removeEventListener('click', this.closeModal);
          this.dialog?.removeEventListener('click', this.handleBackdropClick);
          this.dialog?.removeEventListener('close', this.handleClose);
          document.documentElement.classList.remove('product-inclusions-modal-open');
        }

        openModal(event) {
          event.preventDefault();
          if (this.dialog.open) return;
          this.dialog.showModal();
          document.documentElement.classList.add('product-inclusions-modal-open');
        }

        closeModal() {
          this.dialog.close();
        }

        handleBackdropClick(event) {
          if (event.target === this.dialog) this.closeModal();
        }

        handleClose() {
          document.documentElement.classList.remove('product-inclusions-modal-open');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specifications-modal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-specifications-modal')) {
    customElements.define(
      'product-specifications-modal',
      class ProductSpecificationsModal extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;

          const selector = 'a[href="#' + this.dialog.id + '"]';
          this.triggers = Array.from(document.querySelectorAll(selector));
          this.closeButton = this.querySelector('[data-specifications-close]');
          this.openModal = this.openModal.bind(this);
          this.closeModal = this.closeModal.bind(this);
          this.handleBackdropClick = this.handleBackdropClick.bind(this);
          this.handleClose = this.handleClose.bind(this);

          this.triggers.forEach((trigger) => trigger.addEventListener('click', this.openModal));
          this.closeButton?.addEventListener('click', this.closeModal);
          this.dialog.addEventListener('click', this.handleBackdropClick);
          this.dialog.addEventListener('close', this.handleClose);
        }

        disconnectedCallback() {
          this.triggers?.forEach((trigger) => trigger.removeEventListener('click', this.openModal));
          this.closeButton?.removeEventListener('click', this.closeModal);
          this.dialog?.removeEventListener('click', this.handleBackdropClick);
          this.dialog?.removeEventListener('close', this.handleClose);
          document.documentElement.classList.remove('product-specifications-modal-open');
        }

        openModal(event) {
          event.preventDefault();
          if (this.dialog.open) return;
          this.dialog.showModal();
          document.documentElement.classList.add('product-specifications-modal-open');
        }

        closeModal() {
          this.dialog.close();
        }

        handleBackdropClick(event) {
          if (event.target === this.dialog) this.closeModal();
        }

        handleClose() {
          document.documentElement.classList.remove('product-specifications-modal-open');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
